import { styled } from "@mui/material/styles";
import { alpha, Menu as MuiMenu } from "@mui/material";
import { MenuProps as MuiMenuProps } from "@mui/material";
import { MenuItem as MuiMenuItem } from "@mui/material";

interface MenuProps extends MuiMenuProps {

}

const Menu = ({ open, children, ...props }: MenuProps) => {
	return (
		<StyledMenu open={open}
			slotProps={{ paper: { elevation: 0 } }}
			transformOrigin={{ horizontal: 'right', vertical: 'top' }}
			anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			{...props}
		>
			{children}
		</StyledMenu>
	)
}

const StyledMenu = styled(MuiMenu)(({ theme }) => ({
	'.MuiPaper-root': {
		overflow: 'visible',
		backgroundColor: theme.palette.common.mainBg,
		filter: `drop-shadow(0px 2px 8px ${alpha(theme.palette.common.firstColor, 0.5)})`,
		borderRadius: theme.spacing(0.5),
		marginTop: theme.spacing(1),

		".MuiList-root": {
			minWidth: 200,
			padding: theme.spacing(1, 0),
		},

		'& .MuiAvatar-root': {
			width: 30, height: 30,
		},

		'&::before': {
			content: '""',
			display: 'block',
			top: 0, right: 14,
			position: 'absolute',
			width: 10, height: 10,
			backgroundColor: theme.palette.common.mainBg,
			transform: 'translateY(-50%) rotate(45deg)',
			zIndex: 0,
		},
	},
}))

const CustomMenuItem = styled(MuiMenuItem)(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: theme.spacing(1),

	svg: {
		color: alpha(theme.palette.common.firstColor, 0.75),
	},

	"h1, h2, h3, h4, h5, h6, p, span, a": {
		color: alpha(theme.palette.common.firstColor, 0.8),
		fontWeight: 500,
	}
}))

export { Menu, CustomMenuItem }
